
import { css } from 'lit';
export default css`
.article-card__image {
  position: relative
}
  .article-card__image {
  margin-bottom: 1rem
}
  @media (min-width: 1024px) {
  .article-card__image {
    margin-bottom: 1.25rem
  }
}
  .article-card__category {
  position: absolute
}
  .article-card__category {
  top: 0.75rem
}
  .article-card__category {
  left: 0.75rem
}
  .article-card__category {
  display: flex
}
  .article-card__category {
  flex-direction: row
}
  .article-card__category {
  align-items: center
}
  .article-card__category {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity))
}
  .article-card__category {
  padding: 0.5rem
}
  .article-card__category {
  line-height: 1
}
  .article-card__category {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity))
}
  .article-card__icon {
  margin-right: 0.5rem
}
  .article-card__icon {
  height: 1rem
}
  .article-card__icon {
  width: 1rem
}
  .article-card__label-small {
  margin-bottom: 0.75rem
}
  .article-card__label-small {
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity))
}
  @media (min-width: 1024px) {
  .article-card__label-small {
    margin-bottom: 1rem
  }
}
  .article-card__title {
  margin-bottom: 1rem
}
  .article-card:hover .article-card__image {
  --tw-shadow: 0 0 36px 0px rgba(0,0,0,0.16);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
`;